/*
	Toggle sections
*/

var toggleSection = function (e) {
    e.stopPropagation();
    e.preventDefault();

    var isOpenClass = "is-open";
    
    var target = this.parentElement;

    var content = target.getElementsByClassName("section-toggle-content")[0];
    
    if (target.classList.contains(isOpenClass)) {
        content.style.height = getHeight(0);
        target.classList.remove(isOpenClass);
    } else {
        target.classList.add(isOpenClass);

        content.style.height = 'auto';
        var height = getHeight(content.clientHeight);
        content.style.height = getHeight(0);

        setTimeout(function () {
            content.style.height = height;
        }, 0);
    }
};

function getHeight(height) {
    return height + "px";
}

var toggleSections = document.getElementsByClassName("section-toggle");

for (var i = 0; i < toggleSections.length; i++) {
    var section = toggleSections[i];
    var toggleSectionButton = section.getElementsByClassName("section-toggle-btn")[0];
    
    if (toggleSectionButton) {
        toggleSectionButton.addEventListener("click", toggleSection, false);
    }
}